import * as React from 'react';
import * as Icons from '../icons/dist';
import classNames from 'classnames';
import s from './DefaultProductImage.scss';
import { DEFAULT_IMAGE_DEFAULT_SIZE } from '../constants';
export var DataHook;
(function (DataHook) {
    DataHook["DefaultImage"] = "default-image";
})(DataHook || (DataHook = {}));
export var DefaultProductImage = function (_a) {
    var imageContainerDimensions = _a.imageContainerDimensions, imageSize = _a.imageSize, className = _a.className, _b = _a.dataHook, dataHook = _b === void 0 ? DataHook.DefaultImage : _b;
    var size = imageSize || DEFAULT_IMAGE_DEFAULT_SIZE;
    var containerDimensions = !imageContainerDimensions ? {} : imageContainerDimensions;
    return (React.createElement("div", { "data-hook": dataHook, className: classNames(s.defaultImage, className), style: containerDimensions },
        React.createElement(Icons.DefaultProductImage, { size: size.toString() })));
};
DefaultProductImage.displayName = 'DefaultProductImage';
//# sourceMappingURL=DefaultProductImage.js.map